import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Tints the native status bar (and the nav bar under it) to match the page,
// for pages whose header color depends on the content, like the match
// report's tier tint. Path configuration can only set a fixed color per path.
export default class extends BridgeComponent {
  static component = "status-bar-color"

  connect() {
    super.connect()
    this.send("connect", { color: this.bridgeElement.bridgeAttribute("color") })
  }
}
